import { Component } from "@angular/core";
import { MatDialog } from "@angular/material";
import { NgxSpinnerService } from "ngx-spinner";
import { ClaveUnicaService } from 'src/app/services/clave_unica.service';
import { GLOBAL } from 'src/app/services/global';

@Component({
    selector: 'clave-unica-button',
    templateUrl: './clave_unica_button.component.html',
    styleUrls: ['./clave_unica_button.component.scss'],
    providers: [ClaveUnicaService]
})

export class ClaveUnicaButtonComponent{

    constructor(private spinner: NgxSpinnerService, private claveUnicaService: ClaveUnicaService, private dialog: MatDialog) {

    }


    claveunica() {
        this.spinner.show()
        this.dialog.closeAll()

        this.claveUnicaService.getToken().subscribe(response => {
            const externalUrl = response.url;
            console.log("External url: ", externalUrl);
            const urlObj = new URL(externalUrl);

            const state = urlObj.searchParams.get('state');
            sessionStorage.setItem('authState', state);

            let route = sessionStorage.getItem('selected-route');

            const datos = { state: state, env: GLOBAL.env, route: route };

            this.claveUnicaService.guardarDatos(datos).subscribe(
                (response) => {
                    console.log('Token generado:', response.token);
                    this.spinner.hide()
                    window.open(externalUrl, '_self'); //, '_blank'
                },
                (error) => {
                    console.error('Error al guardar datos de la sesion:', error);
                }
            );
        });



    }
}